import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function TollTagAdd({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>TollTagAdd</title>
      <path
        d="M6 15H9"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 16V18.5M17.5 21V18.5M17.5 18.5H15M17.5 18.5H20"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 15.5V14C21 12.8954 20.1046 12 19 12H5C3.89543 12 3 12.8954 3 14V17C3 18.1046 3.89543 19 5 19H12"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.21705 5.74371C9.41524 4.61357 10.9344 3.98743 12.5151 4.00019C14.0958 4.01295 15.6064 4.66345 16.79 5.81202C17.0637 6.07759 17.0708 6.51525 16.8058 6.78956C16.5408 7.06386 16.1042 7.07093 15.8305 6.80535C14.8829 5.88579 13.7054 5.39248 12.504 5.38278C11.3028 5.37308 10.1202 5.84723 9.16243 6.7506C8.88502 7.01226 8.4485 6.99897 8.18744 6.72092C7.92638 6.44288 7.93964 6.00536 8.21705 5.74371Z"
        fill={color ?? 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.2091 7.8142C10.8679 7.26437 11.6933 6.96467 12.5563 7.00333C13.4179 7.04192 14.2139 7.41293 14.8272 8.01297C15.0705 8.25097 15.055 8.62274 14.7925 8.84335C14.5301 9.06395 14.1201 9.04985 13.8768 8.81185C13.462 8.40605 12.972 8.19855 12.4924 8.17707C12.0142 8.15565 11.5194 8.31774 11.0868 8.67883C10.8235 8.89861 10.4136 8.88322 10.1712 8.64445C9.92886 8.40569 9.94584 8.03397 10.2091 7.8142Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  );
}
